<div class="success-container">
  <mat-card class="success-card">
    <!-- <div class="success-icon-wrapper">
      <mat-icon class="success-icon">check_circle</mat-icon>
    </div> -->
    <h2 class="success-title" *ngIf="userType === 'vendor'">Vendor Registration Successful</h2>
    <h2 class="success-title" *ngIf="userType === 'employee'">Employee Registration Successful</h2>
    <p class="success-message">
      Your {{userType}} registration has been <strong>successfully submitted</strong>.
    </p>

    <p class="success-id">
      <span>Registration ID:</span> <strong>{{ registrationId }}</strong>
    </p>

    <p class="success-note" *ngIf="userType === 'vendor'">
      After approval, you will receive an email notification with further details.
    </p>

    <p class="success-note" *ngIf="userType === 'employee'">
      The login details have been sent to your registered email address.
    </p>

    <div class="success-actions">
            <a href="/login">Go to Login</a>
      <!-- <button mat-raised-button color="primary" routerLink="/login">
        
      </button> -->
    </div>
  </mat-card>
</div>
